import React from 'react';
import { PRODUCT_STATES } from './constants';

export default function ProductStatusText({ state }) {
  const value = state?.databaseValue || state;
  const label =
    PRODUCT_STATES.find(item => item.value && item.value === value)?.label ||
    value ||
    'Без статусу';
  return <span className={`ap-product-state ap-state-${value || 'unknown'}`}>{label}</span>;
}
